import React from 'react';
import './style.less';

const DatePickerIcon = () => (
    <svg className="date-picker__icon" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(-2.000000, -2.000000)" stroke="#323F4D" strokeWidth="1.5">
                <rect x="3" y="5" width="18" height="16" rx="2.5" />
                <path d="M7,3 L7,5"/>
                <path d="M3,9 L21,9"/>
                <path d="M17,3 L17,5"/>
            </g>
        </g>
    </svg>
);

export default DatePickerIcon;
